/*
  Giveaway entry form helpers (progressive: the form works without this file).
  - Counts the entries being claimed (1 + order box + filled social handles) into a hidden
    field and remembers only that number for the "You're entered" message.
  - Blocks the submit if the hidden honeypot field was filled (bots).
  - Notes on this device that an entry was sent (giveaway name, account ID and time only), so
    My Otaku TCG can say "Entry sent" until the entry sync has logged it.
  - "Follow us on ..." buttons: marks the row as followed and, when the visitor comes back
    to the tab, puts the cursor in that row's username field.
  - Stops share links in the username fields: they don't name anyone, so we couldn't check them.
  - "Link your TikTok": keeps what's been typed while the visitor signs in to TikTok, then puts the
    signed username our link server sends back (in the address's # part) into the form.
*/
(function () {
  var KEY = 'otcg-entry-count';
  var SENT_KEY = 'otcg-entry-sent';

  function count(form) {
    var total = 1;
    form.querySelectorAll('[data-otcg-bonus]').forEach(function (el) {
      if (el.type === 'checkbox' ? el.checked : el.value.trim() !== '') total += 1;
    });
    return total;
  }

  function linkTiktok(form) {
    var DRAFT = 'otcg-entry-draft';
    var button = form.querySelector('[data-otcg-tiktok-link]');
    var status = form.querySelector('[data-otcg-tiktok-status]');
    var tokenField = form.querySelector('[data-otcg-tiktok-token]');
    if (!button || !status || !tokenField) return;
    var handle = button.parentNode.querySelector('input[type="text"]');

    button.addEventListener('click', function () {
      var draft = {};
      form.querySelectorAll('input[type="text"], input[type="tel"]').forEach(function (el) {
        if (el.id) draft[el.id] = el.value;
      });
      try {
        window.sessionStorage.setItem(DRAFT, JSON.stringify(draft));
      } catch (e) {}
    });

    var hash = window.location.hash || '';
    var token = (/^#tt=([\w.-]+)$/.exec(hash) || [])[1];
    var failed = /^#tt_error=/.test(hash);
    if (!token && !failed) return;
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(DRAFT) || '{}');
      window.sessionStorage.removeItem(DRAFT);
      Object.keys(saved).forEach(function (id) {
        var el = document.getElementById(id);
        if (el && !el.value) el.value = saved[id];
      });
    } catch (e) {}
    var user = '';
    if (token) {
      try {
        user = JSON.parse(window.atob(token.split('.')[0].replace(/-/g, '+').replace(/_/g, '/'))).u || '';
      } catch (e) {}
    }
    if (user) {
      tokenField.value = token;
      status.textContent = status.dataset.linked.replace('[name]', user);
      if (handle) {
        handle.value = user;
        handle.readOnly = true;
      }
      button.hidden = true;
    } else {
      status.textContent = status.dataset.failed;
    }
    status.hidden = false;
    form.scrollIntoView({ block: 'start' });
  }

  // Also used by "Your linked accounts" on My Otaku TCG.
  function shareLinks() {
    var SHARE_LINK = /(facebook\.com\/share\/|fb\.me\/|(vm|vt)\.tiktok\.com\/|tiktok\.com\/t\/|instagram\.com\/(share|p|reel|reels|stories)\/)/i;
    document.querySelectorAll('[data-otcg-link-warning]').forEach(function (input) {
      function check() {
        input.setCustomValidity(SHARE_LINK.test(input.value) ? input.dataset.otcgLinkWarning : '');
      }
      input.addEventListener('input', check);
      input.addEventListener('change', function () {
        check();
        if (input.validationMessage) input.reportValidity();
      });
    });
  }

  // "Your linked accounts": saved links reach the account when the next sync runs, so until then
  // keep showing what the person just saved on this device instead of an empty box.
  function linkedAccounts() {
    var form = document.querySelector('[data-otcg-linked-form]');
    if (!form) return;
    var KEY_LINKS = 'otcg-linked-saved';
    var inputs = form.querySelectorAll('input[data-otcg-link-warning]');
    form.addEventListener('submit', function () {
      var values = {};
      inputs.forEach(function (el) {
        values[el.id] = el.value;
      });
      try {
        window.localStorage.setItem(KEY_LINKS, JSON.stringify({ at: Date.now(), values: values }));
      } catch (e) {}
    });
    var saved = null;
    try {
      saved = JSON.parse(window.localStorage.getItem(KEY_LINKS) || 'null');
    } catch (e) {}
    if (!saved || !saved.values) return;
    var clean = function (v) {
      return String(v || '').toLowerCase().replace(/^https?:\/\/(www\.|m\.|web\.)?/, '').replace(/^(instagram|tiktok|facebook)\.com\//, '').replace(/[@/]/g, '').split('?')[0];
    };
    var waiting = false;
    inputs.forEach(function (el) {
      var mine = saved.values[el.id];
      if (mine !== undefined && clean(mine) !== clean(el.value)) {
        el.value = mine;
        waiting = true;
      }
    });
    if (Date.now() - saved.at > 3 * 86400000 || !waiting) {
      try {
        window.localStorage.removeItem(KEY_LINKS);
      } catch (e) {}
    }
    var note = form.querySelector('[data-otcg-linked-waiting]');
    if (note && waiting) note.hidden = false;
  }

  function init() {
    shareLinks();
    linkedAccounts();
    var form = document.querySelector('[data-otcg-entry-form]');
    if (!form) return;

    var entered = form.querySelector('[data-otcg-entered]');
    if (entered) {
      var saved = null;
      try {
        saved = window.sessionStorage.getItem(KEY);
      } catch (e) {}
      if (saved) {
        var line = entered.querySelector('[data-otcg-entry-count]');
        var slot = line && line.querySelector('[data-count]');
        if (slot) {
          slot.textContent = saved;
          line.hidden = false;
        }
      }
      entered.focus();
      return;
    }

    var returnTo = null;
    form.querySelectorAll('[data-otcg-follow-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        var row = link.closest('[data-otcg-follow]');
        if (!row) return;
        row.classList.add('is-followed');
        returnTo = row.querySelector('input');
      });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible' || !returnTo) return;
      if (!returnTo.value) returnTo.focus({ preventScroll: false });
      returnTo = null;
    });

    linkTiktok(form);

    form.addEventListener('submit', function (event) {
      var trap = form.querySelector('[data-otcg-honeypot]');
      if (trap && trap.value) {
        event.preventDefault();
        return;
      }
      var total = count(form);
      var field = form.querySelector('[data-otcg-entries-field]');
      if (field) field.value = String(total) + ' (1 WhatsApp group + ' + (total - 1) + ' bonus, to check)';
      try {
        window.sessionStorage.setItem(KEY, String(total));
      } catch (e) {}
      var giveaway = form.querySelector('[data-otcg-giveaway-name]');
      var account = form.querySelector('[data-otcg-account-id]');
      try {
        window.localStorage.setItem(
          SENT_KEY,
          JSON.stringify({ g: giveaway ? giveaway.value : '', a: account ? account.value : '', t: Date.now() })
        );
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
